// extracted by mini-css-extract-plugin
export default {"background":"MainScreen_background__GsMNi","background__filter":"MainScreen_background__filter__Mmgjy","title":"MainScreen_title__0G3W2","subtitle":"MainScreen_subtitle__B6nfh"};